/* unplugin-vue-components disabled */import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=e269f7c6&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e269f7c6"]])

export default __exports__